import Toast from './toast.vue'
import Vue from 'vue'
const obj = {}

obj.install = function (Vue) {

    const toastcontrustor = Vue.extend(Toast)
    const aaa = new toastcontrustor()
    aaa.$mount(document.createElement('div'))
    document.body.appendChild(aaa.$el)
    Vue.prototype.$toast = aaa
}
export default obj